import { EMBEDDED_AGENT_PANEL_WIDTH } from '../pages/ScopedAgentChatPanel';
import {
  CONTEXT_AGENT_SPRITE_SIZE,
  WIDGET_DEFAULT_INSET,
  WIDGET_VIEWPORT_MARGIN,
} from './widgetConstants';

export function getDefaultWidgetAnchor() {
  if (typeof window === 'undefined') {
    return { x: WIDGET_DEFAULT_INSET, y: WIDGET_DEFAULT_INSET };
  }

  return {
    x: window.innerWidth - CONTEXT_AGENT_SPRITE_SIZE - WIDGET_DEFAULT_INSET,
    y: Math.round((window.innerHeight - CONTEXT_AGENT_SPRITE_SIZE) / 2),
  };
}

export function clampWidgetAnchor(anchor) {
  if (typeof window === 'undefined') {
    return anchor;
  }

  const maxX = window.innerWidth - CONTEXT_AGENT_SPRITE_SIZE - WIDGET_VIEWPORT_MARGIN;
  const maxY = window.innerHeight - CONTEXT_AGENT_SPRITE_SIZE - WIDGET_VIEWPORT_MARGIN;

  return {
    x: Math.min(Math.max(WIDGET_VIEWPORT_MARGIN, anchor.x), maxX),
    y: Math.min(Math.max(WIDGET_VIEWPORT_MARGIN, anchor.y), maxY),
  };
}

export function getWidgetPanelHeight() {
  if (typeof window === 'undefined') {
    return 640;
  }

  return Math.min(640, window.innerHeight - 120);
}

export function clampWidgetPanelAnchor(anchor) {
  if (typeof window === 'undefined') {
    return anchor;
  }

  const panelWidth = EMBEDDED_AGENT_PANEL_WIDTH;
  const panelHeight = getWidgetPanelHeight();
  const margin = WIDGET_VIEWPORT_MARGIN;

  return {
    x: Math.min(Math.max(margin, anchor.x), window.innerWidth - panelWidth - margin),
    y: Math.min(Math.max(margin, anchor.y), window.innerHeight - panelHeight - margin),
  };
}

/** Stack panel over sprite — bottom-right corners aligned. */
export function getWidgetPanelAnchorFromSprite(spriteAnchor) {
  const panelWidth = EMBEDDED_AGENT_PANEL_WIDTH;
  const panelHeight = getWidgetPanelHeight();

  return clampWidgetPanelAnchor({
    x: spriteAnchor.x + CONTEXT_AGENT_SPRITE_SIZE - panelWidth,
    y: spriteAnchor.y + CONTEXT_AGENT_SPRITE_SIZE - panelHeight,
  });
}
